import React from 'react';
import ConfirmationModal from '../../../../Components/ModalPopup/ConfirmationModal';

/** The minimum a bulk module must supply to name an excluded product. */
export interface ExcludedProduct {
  devOrderId: string;
  number: string;
}

export interface ProductExclusionModalProps {
  title: string;
  /** Why the products are being excluded — module-specific copy. */
  message: string;
  products: ExcludedProduct[];
  confirmLabel: string;
  onConfirm: () => void;
  /** Closing via ✕. Defaults to `onConfirm`, for modules that offer no way to decline. */
  onClose?: () => void;
}

/**
 * Shared popup for "these selected products cannot be bulk-edited". Renders the module's
 * message above one chip per offending product number, on the standard ConfirmationModal
 * chrome. Both bulk modules that drop products from a selection use it — Measurements for
 * a grading-group mismatch, Design Details for products with no design details — so the
 * exclusion wording and chip layout stay identical across modules.
 */
const ProductExclusionModal: React.FC<ProductExclusionModalProps> = ({ title, message, products, confirmLabel, onConfirm, onClose }) => {
  const numberedProducts = products.filter((product) => Boolean(product.number));

  return (
    <ConfirmationModal
      show
      title={title}
      message={
        <>
          {message}
          {numberedProducts.length > 0 && (
            <div className="bulk-exclusion-chips">
              {numberedProducts.map((product) => (
                <span key={product.devOrderId} className="bulk-exclusion-chip">
                  {product.number}
                </span>
              ))}
            </div>
          )}
        </>
      }
      confirmLabel={confirmLabel}
      confirmVariant="green"
      onConfirm={onConfirm}
      onClose={onClose ?? onConfirm}
    />
  );
};

export default ProductExclusionModal;
